export function getHiddenTableFields(tableHeaders: { isHiddenByDefault?: boolean; value: string }[]): string[] {
  return tableHeaders.map((item) => (item.isHiddenByDefault ? "" : item.value)).filter((item) => Boolean(item));
}
